export default "__VITE_ASSET__e252b724__"